import { createApp } from 'vue'
import { Store } from '../model/store/Store'
import VueScrollTo from 'vue-scrollto'
import MachineCentiu1 from "../component/pages/machineIntroduction/MachineCentiu1.vue"

const unsavedPuriCount = document.getElementById('unsavedPuriCount').textContent
const latestImageId = document.getElementById('latestImageId').textContent.replace(/\s+/g, '')
const isSearchableStr = document.getElementById('isSearchable').textContent
const isSearchable = isSearchableStr.toLowerCase() === "true"

const vue = createApp(
    MachineCentiu1,
    {
        unsavedPuriCount: unsavedPuriCount,
        latestImageId: latestImageId,
        isSearchable: isSearchable,
    }
)
    .use(Store)
    .use(VueScrollTo)
    .mount('#machineCentiu1')

export default vue
